import { render, staticRenderFns } from "./ScheduleDetailProcessTab.vue?vue&type=template&id=51789098"
import script from "./ScheduleDetailProcessTab.vue?vue&type=script&lang=js"
export * from "./ScheduleDetailProcessTab.vue?vue&type=script&lang=js"
import style0 from "./ScheduleDetailProcessTab.vue?vue&type=style&index=0&id=51789098&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports